import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import "../CSS/AgentDashboard.css";
import RegisterStudentModal from "./Regester_student";
import StudentDetailsModal from "./StudentDetailsModal";
import Cookies from "js-cookie";

const API_URL =
  "https://advenwarecareerlink.com/acl/Agent/Display_Agent_clients.php";

const AgentDashboard = () => {

  /* =====================================================
     STATE
  ===================================================== */

  const [students, setStudents] = useState([]);

  const [agent, setAgent] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");

  const [search, setSearch] = useState("");

  const [filter, setFilter] = useState("all");

  const [showRegisterModal, setShowRegisterModal] = useState(false);

  const [agent_name, setAgent_name] = useState('');

  // ADDED: stores the student selected for viewing
  const [selectedStudent, setSelectedStudent] = useState(null);


  useEffect(()=>{

    setAgent_name(Cookies.get("agent_name"));

  },[]);


  /* =====================================================
     FETCH STUDENTS + AGENT INFORMATION
  ===================================================== */

  const fetchStudents = async () => {
    try {
      setLoading(true);
      setError("");

      const agentID = Cookies.get("agent_name");

      if (!agentID) {
        throw new Error("Agent ID not found.");
      }

      const response = await fetch(
        ` ${API_URL}?agent_name=${encodeURIComponent(agentID)}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to load students.");
      }

      const data = await response.json();

      console.log("Students response:", data);


      /* =================================================
         GET AGENT INFORMATION
         ================================================= */

      const agentData =
        data.agent ||
        data.agent_details ||
        data.agentData ||
        data.user ||
        null;

      if (agentData) {
        setAgent({
          name:
            agentData.name ||
            agentData.agent_name ||
            agentData.full_name ||
            agentData.fullName ||
            agentData.username ||
            "Field Agent",

          agentNumber:
            agentData.agentNumber ||
            agentData.agent_number ||
            agentData.agent_ID ||
            agentData.agentID ||
            agentID,
        });
      } else if (
        data.agent_name ||
        data.agentName ||
        data.name
      ) {

        setAgent({
          name:
            data.agent_name ||
            data.agentName ||
            data.name ||
            "Field Agent",

          agentNumber:
            data.agent_number ||
            data.agentNumber ||
            agentID,
        });

      } else {

        setAgent({
          name: "Field Agent",
          agentNumber: agentID,
        });

      }


      /* =================================================
         STUDENTS
         ================================================= */

      const studentsData = Array.isArray(data)
        ? data
        : data.students || [];


      const formattedStudents = studentsData.map(
        (student) => ({

          id:
            student.user_ID ||
            student.ID,

          fullName:
            student.student_name ||
            "",

          systemCode:
            student.systemCode ||
            student.system_code ||
            student.ID ||
            "",

          phone:
            student.phone ||
            student.contact ||
            "",

          course:
            student.course ||
            "",

          institute:
            student.institute ||
            student.institute_name ||
            "",

          county:
            student.county ||
            student.current_county ||
            "",

          cleared:
            student.cleared === true ||
            student.cleared === 1 ||
            student.cleared === "1",

          date:
            student.date ||
            "",

          agent_ID:
            student.agent_ID ||
            "",

          user_ID:
            student.user_ID ||
            "",

          // ADDED: preserve CV from API
          cv:
            student.cv ||
            student.CV ||
            student.cv_url ||
            student.cvUrl ||
            student.resume ||
            student.resume_url ||
            "",

        })
      );


      console.log(
        "Formatted students:",
        formattedStudents
      );


      setStudents(formattedStudents);

    } catch (err) {

      console.error(
        "Fetch students error:",
        err
      );

      setError(
        "Unable to load your registered students."
      );

      setStudents([]);

      setAgent({
        name: "Field Agent",
        agentNumber:
          Cookies.get("userID") || "Agent",
      });

    } finally {

      setLoading(false);

    }
  };


  /* =====================================================
     INITIAL FETCH
  ===================================================== */

  useEffect(() => {

    fetchStudents();

  }, []);


  /* =====================================================
     STATISTICS
  ===================================================== */

  const totalStudents =
    students.length;


  const clearedStudents =
    students.filter(
      (student) =>
        student.cleared === true
    ).length;


  const pendingStudents =
    students.filter(
      (student) =>
        student.cleared !== true
    ).length;


  const clearanceRate =
    totalStudents === 0
      ? 0
      : Math.round(
          (clearedStudents /
            totalStudents) *
            100
        );


  /* =====================================================
     SEARCH + FILTER
  ===================================================== */

  const filteredStudents =
    useMemo(() => {

      return students.filter(
        (student) => {

          const searchValue =
            search
              .toLowerCase()
              .trim();


          const matchesSearch =

            student.fullName
              ?.toLowerCase()
              .includes(searchValue)

            ||

            student.systemCode
              ?.toLowerCase()
              .includes(searchValue)

            ||

            student.course
              ?.toLowerCase()
              .includes(searchValue)

            ||

            student.institute
              ?.toLowerCase()
              .includes(searchValue)

            ||

            student.county
              ?.toLowerCase()
              .includes(searchValue);


          const matchesFilter =

            filter === "all"

            ||

            (
              filter === "cleared" &&
              student.cleared === true
            )

            ||

            (
              filter === "pending" &&
              student.cleared !== true
            );


          return (
            matchesSearch &&
            matchesFilter
          );

        }
      );

    }, [
      students,
      search,
      filter,
    ]);


  /* =====================================================
     REFRESH
  ===================================================== */

  const refreshStudents = async () => {

    await fetchStudents();

  };


  /* =====================================================
     LOGOUT
  ===================================================== */

  const logout = () => {

    console.log(
      "Agent logout"
    );

  };


  /* =====================================================
     VIEW STUDENT
  ===================================================== */

  const viewStudent = (
    student
  ) => {

    console.log(
      "View student:",
      student
    );

    // ADDED: open the student details popup
    setSelectedStudent(student);

  };


  /* =====================================================
     REGISTER STUDENT SUCCESS
  ===================================================== */

  const handleStudentRegistered = (
    newStudent
  ) => {

    if (!newStudent) {
      return;
    }


    setStudents(
      (previousStudents) => [
        newStudent,
        ...previousStudents,
      ]
    );


    setShowRegisterModal(
      false
    );

  };


  /* =====================================================
     AGENT DISPLAY NAME
  ===================================================== */

  const agentName =
    agent?.name ||
    "Field Agent";


  const agentInitial =
    agentName
      .charAt(0)
      .toUpperCase() ||
    "A";


  /* =====================================================
     RENDER
  ===================================================== */

  return (

    <div className="agent-dashboard">

      {/* =================================================
          MAIN
      ================================================= */}

      <main className="agent-main">


        {/* =================================================
            HEADER
        ================================================= */}

        <header className="agent-header">


          <div className="agent-header-content">

            <div className="agent-header-label">

              FIELD AGENT DASHBOARD

            </div>


            {/* =================================================
                WELCOME MESSAGE
            ================================================= */}

            <h1>

              Good day,{" "}

              <span className="agent-welcome-name">

                {agent_name}

              </span>

              {" "}👋

            </h1>


            <p>

              Welcome back,{" "}

              <strong>

                {agent_name}

              </strong>

              . Monitor the students you have
              registered and their clearance status.

            </p>

          </div>


          {/* =================================================
              HEADER RIGHT
          ================================================= */}

          <div className="agent-header-right">


            {/* REFRESH */}

            <button
              className="refresh-button"
              onClick={refreshStudents}
              disabled={loading}
            >

              ↻ &nbsp;

              {loading
                ? "Refreshing..."
                : "Refresh"}

            </button>


            {/* PROFILE */}

            <div className="agent-profile">


              <div className="agent-avatar">

                {agentInitial}

              </div>


              <div>

                <strong>

                  {agentName}

                </strong>


                <span>

                  {agent?.agentNumber ||
                    Cookies.get("userID") ||
                    "Agent"}

                </span>

              </div>

            </div>


            {/* LOGOUT */}

            <button
              className="header-logout"
              onClick={logout}
            >

              Sign out

            </button>


          </div>

        </header>


        {/* =================================================
            ERROR
        ================================================= */}

        {error && (

          <div className="dashboard-error">

            <span>
              !
            </span>

            {error}

            <button
              className="close-error"
              onClick={() =>
                setError("")
              }
            >

              ×

            </button>

          </div>

        )}


        {/* =================================================
            STATISTICS
        ================================================= */}

        <section className="agent-stat-grid">


          {/* TOTAL STUDENTS */}

          <div className="agent-stat-card total">

            <div className="stat-top">

              <span className="stat-label">

                STUDENTS REGISTERED

              </span>

              <div className="stat-icon">

                ♙

              </div>

            </div>


            <strong>

              {loading
                ? "—"
                : totalStudents}

            </strong>


            <span className="stat-description">

              Total students registered by you

            </span>

          </div>


          {/* CLEARED */}

          <div className="agent-stat-card cleared">

            <div className="stat-top">

              <span className="stat-label">

                CLEARED

              </span>

              <div className="stat-icon">

                ✓

              </div>

            </div>


            <strong>

              {loading
                ? "—"
                : clearedStudents}

            </strong>


            <span className="stat-description">

              Students who have been cleared

            </span>

          </div>


          {/* PENDING */}

          <div className="agent-stat-card pending">

            <div className="stat-top">

              <span className="stat-label">

                PENDING CLEARANCE

              </span>

              <div className="stat-icon">

                !

              </div>

            </div>


            <strong>

              {loading
                ? "—"
                : pendingStudents}

            </strong>


            <span className="stat-description">

              Students awaiting clearance

            </span>

          </div>


          {/* RATE */}

          <div className="agent-stat-card rate">

            <div className="stat-top">

              <span className="stat-label">

                CLEARANCE RATE

              </span>

              <div className="stat-icon">

                %

              </div>

            </div>


            <strong>

              {loading
                ? "—"
                : `${clearanceRate}%`}

            </strong>


            <span className="stat-description">

              Overall student clearance

            </span>

          </div>


        </section>


        {/* =================================================
            STUDENTS SECTION
        ================================================= */}

        <section className="students-section">


          {/* =================================================
              STUDENTS HEADER
          ================================================= */}

          <div className="students-header">


            <div>

              <div className="section-label">

                YOUR STUDENTS

              </div>


              <h2>

                Registered students

              </h2>


              <p>

                Students registered through your
                field agent account.

              </p>

            </div>


            {/* REGISTER BUTTON */}

            <button
              className="register-student-button"
              onClick={() =>
                setShowRegisterModal(true)
              }
            >

              + Register student

            </button>


          </div>


          {/* =================================================
              SEARCH + FILTERS
          ================================================= */}

          <div className="student-tools">


            {/* SEARCH */}

            <div className="student-search">

              <span>
                ⌕
              </span>


              <input
                type="text"
                placeholder="Search by name, code, course or institute..."
                value={search}
                onChange={(e) =>
                  setSearch(
                    e.target.value
                  )
                }
              />


              {search && (

                <button
                  className="clear-search"
                  onClick={() =>
                    setSearch("")
                  }
                >

                  ×

                </button>

              )}

            </div>


            {/* FILTERS */}

            <div className="student-filters">


              {/* ALL */}

              <button
                className={
                  filter === "all"
                    ? "filter active"
                    : "filter"
                }
                onClick={() =>
                  setFilter("all")
                }
              >

                All

                <span>

                  {totalStudents}

                </span>

              </button>


              {/* CLEARED */}

              <button
                className={
                  filter === "cleared"
                    ? "filter active"
                    : "filter"
                }
                onClick={() =>
                  setFilter("cleared")
                }
              >

                Cleared

                <span>

                  {clearedStudents}

                </span>

              </button>


              {/* PENDING */}

              <button
                className={
                  filter === "pending"
                    ? "filter active"
                    : "filter"
                }
                onClick={() =>
                  setFilter("pending")
                }
              >

                Pending

                <span>

                  {pendingStudents}

                </span>

              </button>


            </div>

          </div>


          {/* =================================================
              TABLE
          ================================================= */}

          <div className="student-table-container">


            {/* LOADING */}

            {loading ? (

              <div className="students-loading">

                <div className="loading-spinner">
                </div>

                <p>

                  Loading registered students...

                </p>

              </div>


            ) : filteredStudents.length === 0 ? (


              /* EMPTY */

              <div className="students-empty">

                <div className="empty-icon">

                  ♙

                </div>


                <h3>

                  No students found

                </h3>


                <p>

                  There are no students matching
                  your current search or filter.

                </p>

              </div>


            ) : (


              /* TABLE */

              <table className="student-table">


                <thead>

                  <tr>

                    <th>
                      STUDENT
                    </th>

                    <th>
                      ID NUMBER
                    </th>

                    <th>
                      COURSE
                    </th>

                    <th>
                      INSTITUTE
                    </th>

                    <th>
                      COUNTY
                    </th>

                    <th>
                      STATUS
                    </th>

                    <th>
                      ACTION
                    </th>

                  </tr>

                </thead>


                <tbody>

                  {filteredStudents.map(
                    (student) => (

                      <tr
                        key={student.id}
                      >

                        {/* STUDENT */}

                        <td>

                          <div className="student-name">

                            <div className="student-avatar">

                              {student.fullName
                                ?.charAt(0)
                                .toUpperCase() ||
                                "S"}

                            </div>


                            <div>

                              <strong>

                                {student.fullName ||
                                  "Unnamed Student"}

                              </strong>


                              <span>

                                {student.phone ||
                                  "No phone number"}

                              </span>

                            </div>

                          </div>

                        </td>


                        {/* SYSTEM CODE */}

                        <td>

                          <span className="system-code">

                            {student.systemCode ||
                              "N/A"}

                          </span>

                        </td>


                        {/* COURSE */}

                        <td>

                          <span className="course-name">

                            {student.course ||
                              "N/A"}

                          </span>

                        </td>


                        {/* INSTITUTE */}

                        <td>

                          <span className="institute-name">

                            {student.institute ||
                              "N/A"}

                          </span>

                        </td>


                        {/* COUNTY */}

                        <td>

                          <span className="county">

                            {student.county ||
                              "N/A"}

                          </span>

                        </td>


                        {/* STATUS */}

                        <td>

                          {student.cleared ===
                          true ? (

                            <span
                              className={
                                "status " +
                                "cleared-status"
                              }
                            >

                              <i></i>

                              Cleared

                            </span>

                          ) : (

                            <span
                              className={
                                "status " +
                                "pending-status"
                              }
                            >

                              <i></i>

                              Pending

                            </span>

                          )}

                        </td>


                        {/* ACTION */}

                        <td>

                          <button
                            className="view-student"
                            onClick={() =>
                              viewStudent(
                                student
                              )
                            }
                          >

                            View →

                          </button>

                        </td>

                      </tr>

                    )
                  )}

                </tbody>

              </table>

            )}

          </div>


          {/* =================================================
              TABLE FOOTER
          ================================================= */}

          {!loading &&
            filteredStudents.length >
              0 && (

              <div className="student-table-footer">

                <span>

                  Showing{" "}

                  <strong>

                    {filteredStudents.length}

                  </strong>{" "}

                  of{" "}

                  <strong>

                    {totalStudents}

                  </strong>{" "}

                  registered students

                </span>


                <span>

                  Data synchronized with Advenware

                </span>

              </div>

            )}


        </section>


        {/* =================================================
            REGISTER STUDENT POPUP
        ================================================= */}

        {showRegisterModal && (

          <RegisterStudentModal

            onClose={() =>
              setShowRegisterModal(false)
            }

            onStudentRegistered={
              handleStudentRegistered
            }

            refrsh={
              refreshStudents
            }

          />

        )}


        {/* =================================================
            STUDENT DETAILS POPUP
        ================================================= */}

        {selectedStudent && (

          <StudentDetailsModal
            student={selectedStudent}
            onClose={() =>
              setSelectedStudent(null)
            }
          />

        )}


      </main>

    </div>

  );

};


export default AgentDashboard;